/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnalyzedBrick } from './AnalyzedBrick';
import {
    AnalyzedBrickFromJSON,
    AnalyzedBrickFromJSONTyped,
    AnalyzedBrickToJSON,
} from './AnalyzedBrick';

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * Dokument-ID
     * @type {string}
     * @memberof Document
     */
    id: string;
    /**
     * Dateiname
     * @type {string}
     * @memberof Document
     */
    filename: string;
    /**
     * Dateityp
     * @type {string}
     * @memberof Document
     */
    fileType: DocumentFileTypeEnum;
    /**
     * Upload-Datum
     * @type {Date}
     * @memberof Document
     */
    uploadDate: Date;
    /**
     * Analyse-Status
     * @type {string}
     * @memberof Document
     */
    status: DocumentStatusEnum;
    /**
     * Gesamtzahl der Steine (nach Analyse)
     * @type {number}
     * @memberof Document
     */
    totalBricks?: number;
    /**
     * Anzahl geschützter Steine oder "ANALYZING" wenn noch nicht analysiert
     * @type {string}
     * @memberof Document
     */
    protectedBricks?: string;
    /**
     * Anzahl ungeschützter Steine oder "ANALYZING" wenn noch nicht analysiert
     * @type {string}
     * @memberof Document
     */
    unprotectedBricks?: string;
    /**
     * Analysierte Steine
     * @type {Array<AnalyzedBrick>}
     * @memberof Document
     */
    bricksData?: Array<AnalyzedBrick>;
    /**
     * Dateigröße
     * @type {string}
     * @memberof Document
     */
    fileSize?: string;
    /**
     * Anzahl gefundener Sets
     * @type {number}
     * @memberof Document
     */
    setsFound?: number;
}


/**
 * @export
 */
export const DocumentFileTypeEnum = {
    Pdf: 'pdf',
    Csv: 'csv',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type DocumentFileTypeEnum = typeof DocumentFileTypeEnum[keyof typeof DocumentFileTypeEnum];

/**
 * @export
 */
export const DocumentStatusEnum = {
    Analyzing: 'analyzing',
    Analyzed: 'analyzed',
    Error: 'error',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type DocumentStatusEnum = typeof DocumentStatusEnum[keyof typeof DocumentStatusEnum];


/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "fileType" in value;
    isInstance = isInstance && "uploadDate" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'filename': json['filename'],
        'fileType': json['fileType'],
        'uploadDate': (new Date(json['uploadDate'])),
        'status': json['status'],
        'totalBricks': !exists(json, 'totalBricks') ? undefined : json['totalBricks'],
        'protectedBricks': !exists(json, 'protectedBricks') ? undefined : json['protectedBricks'],
        'unprotectedBricks': !exists(json, 'unprotectedBricks') ? undefined : json['unprotectedBricks'],
        'bricksData': !exists(json, 'bricksData') ? undefined : ((json['bricksData'] as Array<any>).map(AnalyzedBrickFromJSON)),
        'fileSize': !exists(json, 'fileSize') ? undefined : json['fileSize'],
        'setsFound': !exists(json, 'setsFound') ? undefined : json['setsFound'],
    };
}

export function DocumentToJSON(value?: Document | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'filename': value.filename,
        'fileType': value.fileType,
        'uploadDate': (value.uploadDate.toISOString()),
        'status': value.status,
        'totalBricks': value.totalBricks,
        'protectedBricks': value.protectedBricks,
        'unprotectedBricks': value.unprotectedBricks,
        'bricksData': value.bricksData === undefined ? undefined : ((value.bricksData as Array<any>).map(AnalyzedBrickToJSON)),
        'fileSize': value.fileSize,
        'setsFound': value.setsFound,
    };
}

